import { NgModule } from "@angular/core";
import { SpinnerModule } from "src/app/common-components/spinner/spinner.module";
import { CommonModule } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";

import { CstButtonsModule } from "src/app/common-components/buttons/buttons.module";

import { TaskFormularEditComponent } from "./task-formular-edit.component";
import { FormularGroupTabComponent } from "./components/formular-group-tab/group-tab.components";
import { FormularGroupTabStammComponent } from "./components/formular-group-tab/stamm/stamm.component";
import { FormularGroupTabInputsComponent } from "./components/formular-group-tab/inputs/inputs.component";
import { FormularGroupTabWartungenComponent } from "./components/formular-group-tab/wartungen/wartungen.component";
import { FormularGroupTabZeiterfassungComponent } from "./components/formular-group-tab/zeiterfassung/zeiterfassung.component";
import { FormularGroupTabBerichteComponent } from "./components/formular-group-tab/berichte/berichte.component";
import { FormularGroupTabSignaturenComponent } from "./components/formular-group-tab/signaturen/signaturen.component";
import { FormularGroupTabDynamicFieldsComponent } from "./components/formular-group-tab/dynamicfields/dynamicfields.component";
import { FormularGroupArtikelComponent } from "./components/formular-group-tab/artikel/artikel.component";
import { FormularGroupArtikelTableComponent } from "./components/formular-group-tab/artikel/table/table.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { FormControlsModule } from "src/app/common-components/form-controls/form-controls.module";
import { CstCardModule } from "src/app/common-components/card/cst-card.module";
import { MatChipsModule } from "@angular/material/chips";
import { CstListViewModule } from "src/app/common-components/list-view/list-view.module";
import { FormularGroupZeiterfassungTableComponent } from "./components/formular-group-tab/zeiterfassung/table/table.component";
import { CommonComponentsModule } from "src/app/common-components";
import { NewOrEditArtikelPopupComponent } from "./components/formular-group-tab/artikel/popup/popup.component";
import { NewOrEditZeiterfassungPopupComponent } from "./components/formular-group-tab/zeiterfassung/popup/popup";
import { FormPlanungResourcesModule } from "src/app/common-components/form-controls/_Planung/resources/form-resources.module";
import { BerichtImageUploadProgressPopupComponent } from "./components/formular-group-tab/berichte/upload-progress-popup/upload-progress-popup";
import { BerichtImageUploadProgressItemComponent } from "./components/formular-group-tab/berichte/upload-progress-popup/image/image.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { CstToolbarModule } from "../../../../common-components/toolbar/cst-toolbar.module";
import { FileUploadModule } from "primeng/fileupload";
import { CommonModule as PrimeCommonModule } from "@angular/common";
import {
  BerichtCtlEvalPipe,
  BerichtImageGalleryComponent,
} from "./components/formular-group-tab/berichte/img-gallery/img-gallery.component";
import { FormularGroupTabInputControlComponent } from "./components/formular-group-tab/inputs/input-field.component";
@NgModule({
  imports: [
    SpinnerModule,
    CommonModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,
    MatNativeDateModule,
    CstButtonsModule,
    FormsModule,
    ReactiveFormsModule,
    FormControlsModule,
    CstCardModule,
    MatChipsModule,
    CstListViewModule,
    CommonComponentsModule,
    FormPlanungResourcesModule,
    MatProgressBarModule,
    CstToolbarModule,
    FileUploadModule,
    PrimeCommonModule,
  ],
  declarations: [
    TaskFormularEditComponent,
    FormularGroupTabComponent,
    FormularGroupTabStammComponent,
    FormularGroupTabInputsComponent,
    FormularGroupTabInputControlComponent,
    FormularGroupTabWartungenComponent,
    FormularGroupTabZeiterfassungComponent,
    FormularGroupTabBerichteComponent,
    FormularGroupTabSignaturenComponent,
    FormularGroupTabDynamicFieldsComponent,
    FormularGroupArtikelComponent,
    FormularGroupArtikelTableComponent,
    FormularGroupZeiterfassungTableComponent,
    NewOrEditArtikelPopupComponent,
    NewOrEditZeiterfassungPopupComponent,
    BerichtImageUploadProgressPopupComponent,
    BerichtImageUploadProgressItemComponent,
    BerichtImageGalleryComponent,
    BerichtCtlEvalPipe,
  ],
  exports: [
    MatTabsModule,
    MatTableModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    TaskFormularEditComponent,
    FormularGroupArtikelTableComponent,
    FormsModule,
    ReactiveFormsModule,
    FormControlsModule,
    CstCardModule,
    MatChipsModule,
    CstListViewModule,
    FormularGroupZeiterfassungTableComponent,
    CommonComponentsModule,
    NewOrEditArtikelPopupComponent,
    NewOrEditZeiterfassungPopupComponent,
    FormPlanungResourcesModule,
    BerichtImageUploadProgressPopupComponent,
    BerichtImageUploadProgressItemComponent,
    MatProgressBarModule,
    CstToolbarModule,
    FileUploadModule,
    PrimeCommonModule,
    BerichtImageGalleryComponent,
    BerichtCtlEvalPipe,
  ],
})
export class FormularEditorModule {}
